module.exports = __webpack_public_path__ + "img/ic_eye_close.0db7caf0.svg";